import GlobalStore from 'dashboard/store';

// "Apps e automacoes" (Slack, Linear, Notion, Shopify, webhooks e dashboard
// apps) nao entra na operacao dos clientes. Fica restrito a um operador unico
// ate que o modulo seja liberado. A regua e o e-mail e nao o papel: um
// administrador da conta continua sem ver a aba nem alcancar as rotas.
const ALLOWED_EMAILS = ['lucas@skalacode.com'];

export const canAccessAppsAutomations = (user = null) => {
  const currentUser = user || GlobalStore.getters.getCurrentUser;
  const email = String(currentUser?.email || '')
    .trim()
    .toLowerCase();

  return ALLOWED_EMAILS.includes(email);
};

export default canAccessAppsAutomations;
